import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
interface BonusSectionProps {
  onImageClick: () => void;
}
export function BonusSection({
  onImageClick
}: BonusSectionProps) {
  const bonuses = [{
    title: 'PLANTILLAS IMPRIMIBLES',
    subtitle: 'Fichas de evaluación y seguimiento listas para usar.',
    value: '$15.000'
  }, {
    title: 'CALENDARIO ANUAL',
    subtitle: 'Planificación macrociclo completa por trimestre.',
    value: '$20.000'
  }, {
    title: 'JUEGOS EXTRA',
    subtitle: '50 dinámicas rompehielo para mantener la atención.',
    value: '$12.000'
  }];
  return <section className="py-24 px-4 bg-gradient-to-b from-brand-dark to-brand-card relative overflow-hidden" data-id="element-25">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-accent to-transparent opacity-50" data-id="element-26"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <span className="inline-block px-4 py-1.5 bg-brand-accent/20 text-brand-accent border border-brand-accent/50 rounded-full text-sm font-bold tracking-wider uppercase mb-4" data-id="element-29">
            Oferta por tiempo limitado
          </span>
          <h2 className="text-4xl md:text-6xl font-display text-brand-cream mb-6 uppercase" data-id="element-30">
            Llevate estos{' '}
            <span className="text-brand-accent" data-id="element-31">BONOS GRATIS</span> hoy
          </h2>
          <p className="text-xl text-brand-cream/80 max-w-2xl mx-auto" data-id="element-32">
            Si accedés a Hockey Infantil 360° hoy, te llevás todo este material
            complementario sin costo adicional.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-33">
          {bonuses.map((bonus, index) => <motion.button key={index} onClick={onImageClick} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} whileHover={{
          y: -4
        }} className="text-left bg-brand-card/70 border border-brand-accent/20 hover:border-brand-accent/60 transition-colors rounded-2xl p-8 relative" data-id="element-34">
              <div className="flex items-start justify-between mb-4" data-id="element-35">
                <div className="w-12 h-12 bg-brand-accent/15 border border-brand-accent/40 rounded-xl flex items-center justify-center" data-id="element-36">
                  <Gift className="w-6 h-6 text-brand-accent" data-id="element-37" />
                </div>
                <span className="bg-brand-accent text-brand-dark text-xs font-bold px-2.5 py-1 rounded uppercase tracking-wider" data-id="element-38">
                  Gratis hoy
                </span>
              </div>
              <h3 className="text-2xl font-display text-brand-cream mb-2 leading-tight" data-id="element-39">
                {bonus.title}
              </h3>
              <p className="text-brand-cream/70 text-sm mb-4" data-id="element-40">
                {bonus.subtitle}
              </p>
              <div className="pt-4 border-t border-white/10" data-id="element-41">
                <span className="text-brand-cream/50 line-through text-sm" data-id="element-42">
                  Valor {bonus.value}
                </span>
              </div>
            </motion.button>)}
        </div>
      </div>
    </section>;
}